"use strict";exports.__esModule = true;exports.default = isSameElement;function isSameElement(parent, element) {
  if (element === parent) {
    return true;
  }
  var parentNode = element.parentNode;
  while (parentNode) {
    if (parentNode === parent) {
      return true;
    }
    parentNode = parentNode.parentNode;
  }
  return false;
}module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/isSameElement.js
// module id = 582
// module chunks = 0